import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { UtilsContext } from '../../provider/utils/context';
import { isValidHttpUrl } from '../../utils/isValidUrl/isValidUrl';
import { ErrorBoundary } from '../../provider/errorBoundary/errorBoundary';
import { ThirdPartyAnimationStandAlone } from './thirdPartyAnimationStandAlone';
const ThirdPartyAnimationWithProviderComponent = ({ autoplay = true, loop = true, urlAnimation, ...props }, ref) => {
    const element = React.useRef(null);
    React.useImperativeHandle(ref, () => {
        return element.current;
    }, []);
    React.useEffect(() => {
        const abortController = new AbortController();
        let animation = undefined;
        const loadAnimation = async () => {
            if (!element.current || !urlAnimation) {
                return;
            }
            try {
                const lottieModule = await import('lottie-web');
                const lottie = lottieModule.default;
                const animationResponse = await fetch(urlAnimation, { signal: abortController.signal });
                if (!animationResponse.ok) {
                    throw new Error(`Failed to fetch animation: ${animationResponse.statusText}`);
                }
                const animationData = await animationResponse.json();
                const newAnimation = lottie.loadAnimation({
                    container: element.current,
                    loop,
                    autoplay,
                    animationData,
                });
                animation = newAnimation;
            }
            catch (error) {
                console.error('Error loading animation:', error);
            }
        };
        loadAnimation();
        return () => {
            animation?.destroy();
            abortController.abort();
        };
    }, [urlAnimation, autoplay, loop]);
    return _jsx(ThirdPartyAnimationStandAlone, { ref: element, ...props });
};
const ThirdPartyAnimationWithProvider = React.forwardRef(ThirdPartyAnimationWithProviderComponent);
const ThirdPartyAnimationHostComponent = (props, ref) => {
    const myContext = React.useContext(UtilsContext);
    const { ANIMATIONS_STYLES } = useTheme();
    const isUrl = isValidHttpUrl(props.animation);
    if (!myContext?.assets && !isUrl) {
        return null;
    }
    let urlAnimation;
    if (props.animation) {
        urlAnimation = isUrl
            ? props.animation
            : `${myContext?.assets?.animationsBaseHost}${ANIMATIONS_STYLES?.[props.animation]}`;
    }
    return (_jsx(ErrorBoundary, { fallBackComponent: _jsx(_Fragment, {}), resetCondition: props.animation, children: _jsx(ThirdPartyAnimationWithProvider, { ...props, ref: ref, urlAnimation: urlAnimation }) }));
};
export const ThirdPartyAnimationHost = React.forwardRef(ThirdPartyAnimationHostComponent);
//# sourceMappingURL=thirdPartyAnimationHost.js.map